import { z } from 'zod';

export const VoucherStatus = z.enum(['Active', 'Expired', 'Used']);

export const Voucher = z.object({
  id: z.string(),
  description: z.string(),
  voucherCode: z.string(),
  status: VoucherStatus,
  issueDate: z.string(),
  expiryDate: z.string(),
  usedDate: z.string().nullable(),
  originalStudentSession: z.string(),
  usedStudentSession: z.string().nullable(),
});
export type Voucher = z.infer<typeof Voucher>;
